import {
  closeDoubleQuote,
  closeSingleQuote,
  ellipsis,
  emDash,
  InputRule,
  openDoubleQuote,
  openSingleQuote,
} from 'prosemirror-inputrules';

import { BaseExtension } from '@lyearn/lygo-core';

export const leftArrow = new InputRule(/<-$/, '←');
export const rightArrow = new InputRule(/->$/, '→');
export const copyright = new InputRule(/\(c\)$/, '©');
export const registeredTrademark = new InputRule(/\(r\)$/, '®');
export const oneHalf = new InputRule(/1\/2$/, '½');
export const plusMinus = new InputRule(/\+\/-$/, '±');
export const notEqual = new InputRule(/!=$/, '≠');
export const laquo = new InputRule(/<<$/, '«');
export const raquo = new InputRule(/>>$/, '»');
export const multiplication = new InputRule(/\d+\s?([*x])\s?\d+$/, '×');

export default class TypographyInputRules extends BaseExtension {
  get name(): string {
    return 'typography_input_rules';
  }

  inputRules() {
    return [
      emDash,
      ellipsis,
      openDoubleQuote,
      closeDoubleQuote,
      openSingleQuote,
      closeSingleQuote,
      leftArrow,
      rightArrow,
      copyright,
      registeredTrademark,
      oneHalf,
      plusMinus,
      notEqual,
      laquo,
      raquo,
      multiplication,
    ];
  }
}
